<template>
  <WsMain>
    <WsCRUD
      ref="WsCRUD"
      pageMode
      orderWay="asc"
      orderBy="sequence"
      exportUrl="/export/content_text/url"
      :label="label"
      :fields="fields"
      :showExpand="false"
      :modelName="modelName"
      :showFields="showFields"
      :filterProps="filterProps"
      :filterSelects="filterSelects"
      @filter-select="$_onFilterSelect"
    >
      <template v-slot:titlebarCustomBtns>
        <WsBtn
          minWidth="100px"
          @click="$_onImportOpen()"
        >
          匯入
        </WsBtn>
      </template>
    </WsCRUD>
    <WsImportDialog
      ref="importDialog"
      :label="label"
      :fields="importFields"
      @create-submit="$_onImport($event)"
    />
  </WsMain>
</template>

<script>
import model from '@/models/contentText';
import Spare_module from '@/spare/module';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      importFields: {
        content_text: {
          type: 'file',
          label: '文案 (檔案格式限制: xlsx)',
          uploadUrl: '/import/content_text',
          maxWidth: '100px',
          accept: '.xlsx',
          rules: 'required',
        },
      },
      showFields: [
        'sequence',
        'label',
        'for',
        'module',
        'is_user_editable',
        'updated_at',
        'updated_admin',
      ],
      filterSelects: [
        {
          type: 'select',
          label: '適用前後台',
          items: [
            {
              text: '前台',
              value: 'app',
            },
            {
              text: '後台',
              value: 'platform',
            },
          ],
          paramName: 'for',
          placeholder: '請選擇適用前後台',
        },
        {
          type: 'select',
          label: '模組',
          items: Spare_module.list,
          paramName: 'module',
          placeholder: '請選擇模組',
        },
        {
          type: 'switch',
          label: '前台使用者是否可編輯',
          defaultValue: false,
          activeText: '可以',
          inactiveText: '不可以',
          paramName: 'is_user_editable',
        },
      ],
      filterProps: {},
    };
  },
  methods: {
    $_onImportOpen() {
      this.$refs.importDialog.open();
    },
    async $_onImport($event) {
      this.$refs.importDialog.startLoading();
      try {
        await this.$axios.post(
          `${$event.uploadUrl}`,
          $event.formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        this.$refs.importDialog.stopLoading();
        this.$refs.importDialog.close();
        await this.$refs.WsCRUD.$_fetchData();
      } catch (error) {
        alert(error)
      } finally {
        this.$refs.importDialog.stopLoading();
      }
    },
    $_onFilterSelect($event) {
      this.filterProps = {
        ...$event,
        is_user_editable: $event.is_user_editable ? 1 : 0,
      };
    },
  },
};
</script>